const unsupportedNode = require('./helper').unsupportedNode;

module.exports = unsupportedNode('Inclusive gateways not supported by execution engine','bpmn:InclusiveGateway');
